export default "__VITE_ASSET__BDTU2GqZ__"